import { defineMessages } from 'react-intl';

export default defineMessages({
  appBarDisconnectTitle: {
    id: 'app_bar.disconnect_title',
  },
  stepperIdentification: {
    id: 'stepper.identification',
  },
  stepperPreopening: {
    id: 'stepper.preopening',
  },
  stepperCompleteOpening: {
    id: 'manager_page.complete_opening_claim',
  },
  stepperUploadDocs: {
    id: 'stepper.upload_docs',
  },
  stepperSummary: {
    id: 'stepper.summary',
  },
  judiciaryProcess: {
    id: 'stepper.judiciary_process',
  },
  sideBarHomeTitle: {
    id: 'side_bar.home_title',
  },
  sideBarValidatedTitle: {
    id: 'side_bar.validated_title',
  },
  sideBarPendingTitle: {
    id: 'side_bar.pending_title',
  },
  sideBarOpenedTitle: {
    id: 'side_bar.opened_title',
  },
  sideBarRejectedTitle: {
    id: 'side_bar.rejected_title',
  },
  sideBarManagerDocumentsTitle: {
    id: 'side_bar.manager_documents_title',
  },
  sideBarNewDocTitle: {
    id: 'side_bar.new_doc_title',
  },
  sideBarAffectedClaim: {
    id: 'side_bar.affected_claim',
  },
  sideBarLawyerAssignment: {
    id: 'side_bar.lawyer_assigned_claims',
  },
  sideBarFeeNote: {
    id: 'side_bar.fee_note',
  },
  sideBarNotificationTitle: {
    id: 'side_bar.notification',
  },
  sideBarNotificationDialogContent: {
    id: 'side_bar.notification.dialog.title',
  },
  sideBarNotificationDialogCancel: {
    id: 'side_bar.notification.dialog.cancel',
  },
  sideBarNotificationDialogConfirm: {
    id: 'side_bar.notification.dialog.confirm',
  },
  sideBarNotificationDialogTitle: {
    id: 'side_bar.notification.dialog.confirmation',
  },
  sideBarNotificationDialogInfo: {
    id: 'side_bar.notification.dialog.info_message',
  },
  emptyMessage: {
    id: 'side_bar.empty_notification.title',
  },
  openStep: {
    id: 'opening_gestionnaire.open_step',
  },
  managementMethodStep: {
    id: 'opening_gestionnaire.open_management_method',
  },
  newSinistersTitle: {
    id: 'side_bar.newSinistersTitle',
  },
  assignedDossiers: {
    id: 'expert.side_menu.assignedDossiers',
  },
  processedDossiers: {
    id: 'expert.side_menu.processedDossiers',
  },
  sideBarAdministration: {
    id: 'side_bar.administration',
  },
  unlockClaim: {
    id: 'side_bar.administration.unlock_claim',
  },
  unlockClaimDialogDescription: {
    id: 'unlock_claim_dialog.title',
  },
  unlockClaimDialogLabelInput: {
    id: 'unlock_claim_dialog.unlock_claim_by_code_label',
  },
  unlockClaimSuccessToast: {
    id: 'unlock_claim_dialog.success_toast',
  },
  attributionOpeningTitle: {
    id: 'side_bar.administration.attribution_opening',
  },
  attributionJudiciaryTitle: {
    id: 'side_bar.administration.attribution_judiciary',
  },
  attributionTransactionTitle: {
    id: 'side_bar.administration.attribution_transaction',
  },
  inboxesDrawerTitle: {
    id: 'manager_inboxes.drawer.title',
  },
  readByTitle: {
    id: 'inboxe.read_by.title',
  },
  treatedByTitle: {
    id: 'inboxe.treated_by.title',
  },
  claimNotExist: {
    id: 'inboxe.claim.not.exist',
  },
  pendingTreatementClaims: {
    id: 'side_bar.pending_treatement_title',
  },
  sideBarNotificationDialogContentLawyer: {
    id: 'side_bar.notification.dialog_lawyer.title',
  },
  assignExpertTitle: {
    id: 'notification.assignement_expert.title',
  },
  restrictedAccess: {
    id: 'restricted_access_page.title',
  },
  restrictedAccessDescription: {
    id: 'restricted_access_page.description',
  },
  MailServiceDesk: {
    id: 'restricted_access_page_mail.title',
  },
  TelServiceDesk: {
    id: 'restricted_access_page_tel.title',
  },
  assignementInboxeTitle: {
    id: 'notification.assignement_inboxe.title',
  },
  platformManagerTitle: {
    id: 'administration.platform_manager.title',
  },
  platformManagerIntervenantTitle: {
    id: 'administration.platform_manager_intervenant.title',
  },
  sideBarCourtMonitoringProvisionalClaims: {
    id: 'side_bar.court_monitoring_provisional_claims',
  },
  sideBarUsageClaimsTitle: {
    id: 'lawyer_side_bar.usage_claims_title',
  },
});
